/**
 * Storezone — ErrorState
 */

import { type ReactNode } from 'react'
import { Icons } from '@/lib/icons'
import './ErrorState.css'

export interface ErrorStateProps {
  title?: string
  message?: string
  onRetry?: () => void
  action?: ReactNode
}

export function ErrorState({
  title = 'Something went wrong',
  message = 'An unexpected error occurred. Please try again.',
  onRetry,
  action,
}: ErrorStateProps) {
  return (
    <div className="sz-error-state">
      <div className="sz-error-state__icon">
        <Icons.AlertCircle size={28} />
      </div>
      <h3 className="sz-error-state__title">{title}</h3>
      <p className="sz-error-state__message">{message}</p>
      <div className="sz-error-state__actions">
        {onRetry && (
          <button className="sz-error-state__retry" onClick={onRetry}>
            <Icons.Refresh size={14} /> Try again
          </button>
        )}
        {action}
      </div>
    </div>
  )
}
